module.exports = __webpack_public_path__ + "static/media/Overview_150.accf0024.png";